import { PublicClientApplication, type Configuration } from "@azure/msal-browser";

import { useStoreLayout } from "features/layout/store";
import { useSettings } from "features/start/fabric";


let msal: PublicClientApplication | null = null;

export const useLayout = () => {
	const layout = useStoreLayout();


	const redirect = "/";
	return { ...layout, redirect };
};

export const useLayoutMsal = () => {
	const settings = useSettings();

	if (!msal && settings) {
		const msalOptions = {
			auth: {
				clientId: settings.azureAd.clientId,
				authority: `${settings.azureAd.instance}${settings.azureAd.tenantId}`,
				redirectUri: `https://${location.host}`
			},
			cache: {
				cacheLocation: "localStorage",
				storeAuthStateInCookie: false
			}
		} satisfies Configuration;

		msal = new PublicClientApplication(msalOptions);
	}

	return { msal };
};